function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avia_tab_svg__clip0_1993_871)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.501 19.905l-2.32-8.966 3.89-3.889a1.498 1.498 0 000-2.121 1.498 1.498 0 00-2.122 0L13.06 8.818l-8.966-2.32a1.038 1.038 0 00-1.004.27 1.051 1.051 0 00.234 1.661l6.547 3.578-3.882 3.882-2.552-.643a.508.508 0 00-.474.134l-.41.41a.501.501 0 00.092.785l2.58 1.549.41.24.206.332.22.375 1.003 1.683.354.594c.17.283.551.325.785.092l.41-.41a.495.495 0 00.134-.474l-.636-2.546L12 14.121l3.578 6.548a1.04 1.04 0 001.923-.764z",
  fill: "#FF8E01"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avia_tab_svg__clip0_1993_871"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})));
function SvgAviaTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgAviaTab;